<template>
    <component
        :is="artist?.showAsLink ? NuxtLink : 'span'"
        v-for="(artist, index) in artistsParsed"
        :key="artist?.id ?? index"
        v-bind="
            artist.showAsLink && artist.to
                ? { to: artist.to }
                : {}"
        class="event-artist"
    >
        <ArtistAvatar
            v-if="artist.avatar && artist.hasPage"
            :avatar="artist.avatar"
            :tiny="true"
        />

        <span>
            {{ artist.name }}
        </span>

        {{ artists.length > 1 && index !== artists.length - 1 ? ',' : '' }}
    </component>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        artists: ArtistRelation[];
        centered?: boolean;
    }>(),
    {
        centered: false,
    }
);

const NuxtLink = resolveComponent('NuxtLink');

const route = useRoute();

const artistsParsed = computed(() => props.artists.map((artist) => {
    const showAsLink = artist.hasPage && route.params.slug !== artist.slug;

    return {
        ...artist,
        showAsLink,
        to: showAsLink ? `/makers/${artist.slug}` : null,
    };
}));
</script>

<style lang="less">
.event-artist {
    display: flex;
    align-items: center;
}

.event-artist .artist-avatar {
    margin-bottom: .25rem;
    margin-right: .25rem;
}
</style>
